import { Icon, Table } from '@aon/aon-tws-common-ui';
import { ITableRowProps, TableRow } from '@aon/aon-tws-common-ui/build/lib/components/Table/TableRow';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import styled from 'styled-components';

// Style copies from Hierarchy Manager Attribute editor.
// TODO: Put in CommonUI when style requirements are finalized.
export const ExpandableRowTable = styled(Table)`
	&.table tbody tr {
		&.tws-table-row td {
			&.tws-table-column:first-child {
				min-width: 30px !important;
			}
		}
	}
	tbody tr td:not(:first-child) {
		padding-left: 17px !important;
	}
	thead tr th:not(:first-child) {
		padding-left: 17px !important;
	}
	thead tr th:first-child {
		padding-left: 30px !important;
		min-width: 15px !important;
	}
`;

export const StyledOpenColumn = styled.td`
	background-color: ${globalVars.tertiaryBlue2} !important;
	cursor: pointer;
	border-left: 0;
	width: 30px;
	padding-left: 5px !important;
	padding-right: 15px !important;
`;

StyledOpenColumn.displayName = 'StyledOpenColumn';

const IconContainer = styled.div`
	color: white;
`;

export interface IExpandableTableRowProps {
	onIconClick?: (key?: string, event?: any) => void;
}

export class ExpandableTableRow extends React.Component<React.PropsWithChildren<ITableRowProps & IExpandableTableRowProps>> {
	public render() {
		return (
			<TableRow {...this.props}>
				<StyledOpenColumn className='tws-table-column' onClick={(e: any) => this.props.onIconClick!(e)}>
					<IconContainer>
						<Icon name={this.props.expanded ? 'angle-up' : 'angle-down'} />
					</IconContainer>
				</StyledOpenColumn>
				{this.props.children}
			</TableRow>
		);
	}
}
